<div class="d-flex">
  <mat-form-field class="search-bar" appearance="outline">
    <input matInput type="number" placeholder="Jobnr" [(ngModel)]="projectId" />
  </mat-form-field>
  <ng-container *ngIf="loading; else showSearch">
    <mat-spinner color="primary" diameter="24"></mat-spinner>
  </ng-container>
  <ng-template #showSearch>
    <button
      mat-flat-button
      class="button"
      (click)="search()"
      [disabled]="projectId == null"
    >
      Zoek
    </button>
  </ng-template>
</div>
